'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.definitionListStyle = undefined;
var _themeUtilities = require('../theme-utilities');
var _themeUtilities2 = _interopRequireDefault(_themeUtilities);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var definitionListStyle = exports.definitionListStyle = function definitionListStyle() {
  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }
  return _themeUtilities2.default.apply(undefined, ['DefinitionList'].concat(styles));
};
var definitionListTheme = function definitionListTheme(baseTheme) {
  var _Object$assign;
  return Object.assign((_Object$assign = {}, _defineProperty(_Object$assign, definitionListStyle('definitionBackgroundColor'), baseTheme.colorDefinition), _defineProperty(_Object$assign, definitionListStyle('definitionColor'), baseTheme.colorBase), _defineProperty(_Object$assign, definitionListStyle('descriptionBackgroundColor'), baseTheme.colorWhite), _defineProperty(_Object$assign, definitionListStyle('offWhiteDescriptionBackgroundColor'), baseTheme.colorOffWhite), _Object$assign), baseTheme);
};
exports.default = {
  definitionListTheme: definitionListTheme,
  definitionListStyle: definitionListStyle
};